import React, { useContext, useEffect, useRef, useState } from "react";
import { Moments } from "../../context/MomentsContextProvider";
import { memberPhotoUrl, allMembers } from "../../api";
import { TransitionGroup, Transition } from "react-transition-group";
import { gsap, Power2 } from "gsap";
import IconLocation from "../../img/location-pin.svg";
import IconTags from "../../img/tag.svg";
import { Cache } from "../Cache";

const Filter = ({ ...props }) => {
    const inputTextRef = useRef(null);
    const momentsContext = useContext(Moments);
    const { setFilter, setFilterLeft, setFilterRight } = momentsContext;
    const [searchMode, setSeachMode] = useState(false);
    const [recentFilterArray, setRecentFilterArray] = useState([]);
    const [searchResults, setSearchResults] = useState([]);
    let failedResultTimeline = null;

    let firstAllMembers = JSON.parse(JSON.stringify(allMembers));

    let __filter;
    if (props.isVertical && props.isLeft) {
        __filter = JSON.parse(JSON.stringify(momentsContext.filterLeft));
    } else if (props.isVertical && !props.isLeft) {
        __filter = JSON.parse(JSON.stringify(momentsContext.filterRight));
    } else {
        __filter = JSON.parse(JSON.stringify(momentsContext.filter));
    }

    const setAllFilters = (filter) => {
        // mute all videos on filter change.
        for (const key in Cache.videos) {
            Cache.videos[key].pause();
            Cache.videos[key].muted = true;
        }

        if (props.isVertical && props.isLeft) {
            console.log("set filter left");
            setFilterLeft(filter);
        } else if (props.isVertical && !props.isLeft) {
            console.log("set filter right");
            setFilterRight(filter);
        } else {
            console.log("set filter default");
            setFilter(filter);
            setFilterLeft(filter);
            setFilterRight(filter);
        }
    };

    // compare and sort allMembers and Locations
    const dynamicSort = (_sortArray) => {
        _sortArray.sort((a, b) => {
            if (a.firstName && b.firstName) {
                return a.firstName < b.firstName ? -1 : a.firstName === b.firstName ? 0 : 1;
            } else if (a.firstName && !b.firstName) {
                return a.firstName < b ? -1 : a.firstName === b ? 0 : 1;
            } else if (b.firstName && !a.firstName) {
                return a < b.firstName ? -1 : a === b.firstName ? 0 : 1;
            } else {
                return a < b ? -1 : a === b ? 0 : 1;
            }
        });
    };

    useEffect(() => {
        // run this funciton only once.
        // Create initial values to populate recent searches array.
        const initialfilterArray = firstAllMembers.concat(momentsContext.locations, momentsContext.tags);
        dynamicSort(initialfilterArray);
        // console.log("InitailArray", initialfilterArray);
        const initialFilter = initialfilterArray.filter((_member) => {
            return _member.firstName || _member.charAt(0).match(/[a-zA-Z]/);
        });

        setRecentFilterArray(initialFilter);
    }, []);

    const removeLocation = () => {
        __filter.location = [];
        setAllFilters(__filter);
    };

    const removeTags = (tag) => {
        console.log("tags before:", __filter.tags);
        __filter.tags = __filter.tags.filter((_tag) => _tag !== tag);
        console.log("tags after:", __filter.tags);
        setAllFilters(__filter);
    };

    const removeMember = (memberID) => {
        __filter.members = __filter.members.filter((_ID) => {
            return _ID !== memberID;
        });
        setAllFilters(__filter);
    };
    const clearAllFilters = () => {
        __filter.location = [];
        __filter.tags = [];
        __filter.members = [];
        setAllFilters(__filter);
    };

    const toggleSearchFilters = () => {
        if (!searchMode && inputTextRef.current) {
            inputTextRef.current.value = "";
            setSearchResults({ data: recentFilterArray.slice(0, 3) });
            setTimeout(() => {
                inputTextRef.current.focus();
            }, 50);
        }
        setSeachMode(!searchMode);
    };
    const hideSearchFilter = () => {
        if (searchMode) {
            setSeachMode(false);
        }
    };

    const _locations = JSON.parse(JSON.stringify(momentsContext.locations));
    const _allMembers = JSON.parse(JSON.stringify(allMembers));
    const _tags = JSON.parse(JSON.stringify(momentsContext.tags));

    const onTypeSearch = (e) => {
        let query = e.target.value;

        let searchArray = [];
        if (searchMode) {
            if (query.length > 0) {
                let memberMatch = _allMembers.filter((member) => {
                    return member.firstName.slice(0, query.length).toLowerCase() === query.toLowerCase();
                });

                let locationMatch = _locations.filter((location) => {
                    return location.slice(0, query.length).toLowerCase() === query.toLowerCase();
                });

                let tagMatch = _tags.filter((tag) => {
                    return tag.slice(0, query.length).toLowerCase() === query.toLowerCase();
                });

                // return 3 search results
                if (memberMatch.length > 0 || locationMatch.length > 0 || tagMatch.length > 0) {
                    searchArray = memberMatch.concat(locationMatch, tagMatch);
                    dynamicSort(searchArray);
                    setSearchResults({
                        data: [...searchArray].slice(0, 3),
                    });
                }
            } else {
                setSearchResults({ data: recentFilterArray.slice(0, 3) });
            }
        }
    };

    const selectResult = (result) => {
        console.log("Result", result);
        let __filterBackup = JSON.parse(JSON.stringify(__filter));
        let alreadyInFilter = false;
        if (result.id) {
            // is a member
            if (__filter.members.find((_m) => _m === result.id)) {
                alreadyInFilter = true;
            } else {
                __filter.members.push(result.id);
            }
        } else if (momentsContext.tags.find((_tags) => _tags === result)) {
            // is a tag
            if (__filter.tags.find((_tag) => _tag === result)) {
                console.log("already in tag");
                alreadyInFilter = true;
            } else {
                console.log("adding to tag tag");
                __filter.tags.push(result);
            }
        } else {
            // is a location
            if (__filter.location === result) {
                alreadyInFilter = true;
            } else {
                __filter.location = [result];
            }
        }
        const filterResults = momentsContext.checkFilter(__filter);
        if (filterResults.length && !alreadyInFilter) {
            setAllFilters(__filter);
            setSeachMode(false);
            setRecentFilterArray([...new Set([result, ...recentFilterArray])]);
        } else {
            __filter = __filterBackup;
            const resultID = result.id ? "#result-" + result.id : "#result-" + result.split(" ").join("-");

            // shake icon.
            if (failedResultTimeline) failedResultTimeline.kill();
            failedResultTimeline = new gsap.timeline({}).to(resultID, { x: 7, duration: 0.1, ease: Power2.easeOut }).to(resultID, { x: -7, duration: 0.15, ease: Power2.easeInOut }).to(resultID, { x: 0, duration: 0.1, ease: Power2.easeInOut });
        }
    };

    // search panel width
    const getStyle = () => {
        const { filter, filterLeft, filterRight } = momentsContext;
        const baseWidth = 80;
        let itemsWidth;
        if (props.isVertical && props.isLeft) {
            itemsWidth = filterLeft.members.length > 0 || filterLeft.location.length > 0 || filterLeft.tags.length > 0 ? filterLeft.members.length * 55 + filterLeft.location.length * 55 + filterLeft.tags.length * 55 + 20 : 0;
        } else if (props.isVertical && !props.isLeft) {
            itemsWidth = filterRight.members.length > 0 || filterRight.location.length > 0 || filterRight.tags.length > 0 ? filterRight.members.length * 55 + filterRight.location.length * 55 + filterRight.tags.length * 55 + 20 : 0;
        } else {
            itemsWidth = filter.members.length > 0 || filter.location.length > 0 || filter.tags.length > 0 ? filter.members.length * 55 + filter.location.length * 55 + filter.tags.length * 55 + 20 : 0;
        }

        return {
            width: searchMode ? 160 : baseWidth + itemsWidth,
            height: searchMode ? 200 : 100,
        };
    };

    const checkLabelLength = (_label) => {
        return _label.length > 9 ? _label.slice(0, 9) + "..." : _label;
    };

    const getSearchClass = () => {
        //
        if (searchMode) {
            return "filter search-mode";
        } else {
            if (__filter.location.length > 0 || __filter.members.length > 0 || __filter.tags.length > 0) {
                return "filter";
            } else {
                return "filter empty";
            }
        }
    };

    return (
        <div className="moments-filter">
            <div style={getStyle()} className={getSearchClass()}>
                <div className="filter-wrapper">
                    <div className="search">
                        <div className="icon-search" onClick={toggleSearchFilters} />
                        <div className="label">find</div>
                    </div>
                    {(__filter.location.length > 0 || __filter.members.length > 0 || __filter.tags.length > 0) && !searchMode ? <div className="divider"></div> : ""}
                    {
                        // if members
                        <TransitionGroup className="filter-items">
                            {searchMode
                                ? ""
                                : __filter.members.map((memberID) => {
                                      const member = allMembers.find((_member) => {
                                          return _member.id === memberID;
                                      });
                                      const style = {
                                          backgroundImage: `url(${memberPhotoUrl(member.photo)})`,
                                      };
                                      return (
                                          <Transition
                                              key={member.id}
                                              unmountOnExit
                                              mountOnEnter
                                              timeout={400}
                                              onEnter={(node) => {
                                                  gsap.set(node, {
                                                      y: 0,
                                                      scale: 1,
                                                      opacity: 1,
                                                  });
                                              }}
                                              onEntering={(node) => {
                                                  gsap.from(node, {
                                                      duration: 0.2,
                                                      delay: 0.2,
                                                      y: "10",
                                                      scale: 0.3,
                                                      opacity: 0,
                                                      ease: Power2.easeOut,
                                                  });
                                              }}
                                              onExit={(node) => {
                                                  gsap.to(node, {
                                                      duration: 0.2,
                                                      delay: 0,
                                                      y: "10",
                                                      opacity: 0,
                                                      scale: 0.3,
                                                      ease: Power2.easeIn,
                                                  });
                                              }}
                                              onExited={(node) => {
                                                  gsap.killTweensOf(node);
                                              }}
                                          >
                                              <div className="member">
                                                  <div className="member-photo" style={style}></div>
                                                  <div className="label">{checkLabelLength(member.firstName)}</div>
                                                  <div
                                                      className="remove"
                                                      onClick={() => {
                                                          removeMember(member.id);
                                                      }}
                                                  ></div>
                                              </div>
                                          </Transition>
                                      );
                                  })}
                            {searchMode
                                ? ""
                                : __filter.location.map((location) => {
                                      return (
                                          <Transition
                                              key={location.id}
                                              unmountOnExit
                                              mountOnEnter
                                              timeout={400}
                                              onEnter={(node) => {
                                                  gsap.set(node, {
                                                      y: 0,
                                                      scale: 1,
                                                      opacity: 1,
                                                  });
                                              }}
                                              onEntering={(node) => {
                                                  gsap.from(node, {
                                                      duration: 0.2,
                                                      delay: 0.2,
                                                      y: "10",
                                                      scale: 0.3,
                                                      opacity: 0,
                                                      ease: Power2.easeOut,
                                                  });
                                              }}
                                              onExit={(node) => {
                                                  gsap.to(node, {
                                                      duration: 0.2,
                                                      delay: 0,
                                                      y: "10",
                                                      opacity: 0,
                                                      scale: 0.3,
                                                      ease: Power2.easeIn,
                                                  });
                                              }}
                                              onExited={(node) => {
                                                  gsap.killTweensOf(node);
                                              }}
                                          >
                                              <div className="location">
                                                  <div className="icon-location"></div>
                                                  <div className="label">{checkLabelLength(location)}</div>
                                                  <div className="remove" onClick={removeLocation}></div>
                                              </div>
                                          </Transition>
                                      );
                                  })}
                            {searchMode
                                ? ""
                                : __filter.tags.map((tag) => {
                                      return (
                                          <Transition
                                              key={tag.id}
                                              unmountOnExit
                                              mountOnEnter
                                              timeout={400}
                                              onEnter={(node) => {
                                                  gsap.set(node, {
                                                      y: 0,
                                                      scale: 1,
                                                      opacity: 1,
                                                  });
                                              }}
                                              onEntering={(node) => {
                                                  gsap.from(node, {
                                                      duration: 0.2,
                                                      delay: 0.2,
                                                      y: "10",
                                                      scale: 0.3,
                                                      opacity: 0,
                                                      ease: Power2.easeOut,
                                                  });
                                              }}
                                              onExit={(node) => {
                                                  gsap.to(node, {
                                                      duration: 0.2,
                                                      delay: 0,
                                                      y: "10",
                                                      opacity: 0,
                                                      scale: 0.3,
                                                      ease: Power2.easeIn,
                                                  });
                                              }}
                                              onExited={(node) => {
                                                  gsap.killTweensOf(node);
                                              }}
                                          >
                                              <div className="tag">
                                                  <div className="icon-tag"></div>
                                                  <div className="label">{checkLabelLength(tag)}</div>
                                                  <div
                                                      className="remove"
                                                      onClick={() => {
                                                          removeTags(tag);
                                                      }}
                                                  ></div>
                                              </div>
                                          </Transition>
                                      );
                                  })}
                        </TransitionGroup>
                    }
                    {(__filter.location.length > 0 || __filter.members.length > 0 || __filter.tags.length > 0) && !searchMode ? <div className="clear-filters" onClick={clearAllFilters} /> : ""}
                </div>
                <div className="results-wrapper">
                    <div className="results-header">
                        <div className="icon-search" onClick={hideSearchFilter}></div>
                        <input className="search-input" type="text" onKeyUp={onTypeSearch} ref={inputTextRef} />
                        <span className="close" onClick={hideSearchFilter}></span>
                    </div>
                    {
                        <TransitionGroup className="search-results">
                            {searchMode
                                ? searchResults.data.map((result, i) => {
                                      const getBackground = {
                                          backgroundImage: `url(${momentsContext.tags.find((_tags) => _tags === result) ? IconTags : result.photo ? memberPhotoUrl(result.photo) : IconLocation})`,
                                      };
                                      return (
                                          <Transition
                                              key={"k-" + Math.random()}
                                              unmountOnExit
                                              mountOnEnter
                                              timeout={500}
                                              onEnter={(node) => {
                                                  gsap.set(node, {
                                                      x: 0,
                                                      opacity: 1,
                                                      display: "none",
                                                  });
                                              }}
                                              onEntering={(node) => {
                                                  gsap.from(node, {
                                                      duration: 0.2,
                                                      delay: 0.2 + 0.05 * i,
                                                      x: "-10",
                                                      opacity: 0,
                                                      ease: Power2.easeOut,
                                                  });
                                                  gsap.set(node, {
                                                      display: "flex",
                                                      delay: 0.2 + 0.05 * i,
                                                  });
                                              }}
                                              onExit={(node) => {
                                                  gsap.to(node, {
                                                      duration: 0.2,
                                                      display: "none",
                                                      delay: 0,
                                                      x: "10",
                                                      opacity: 0,
                                                      ease: Power2.easeIn,
                                                  });
                                              }}
                                              onExited={(node) => {
                                                  gsap.killTweensOf(node);
                                              }}
                                          >
                                              <div
                                                  className="result"
                                                  id={result.id ? "result-" + result.id : "result-" + result.split(" ").join("-")}
                                                  onClick={() => {
                                                      selectResult(result);
                                                  }}
                                              >
                                                  <div className="icon" style={getBackground}></div>
                                                  <div className="label">{result.firstName ? result.firstName : result}</div>
                                              </div>
                                          </Transition>
                                      );
                                  })
                                : ""}
                        </TransitionGroup>
                    }
                </div>
            </div>
        </div>
    );
};

export default Filter;
